export const ENTITY = "FUNCTION_REGISTER";
export const NAME_ENTITY = "FUNCTION_NAMES";
export const TASK_ENTITY = "FUNCTION_TASK";
